import { isNextWorkingDay } from './isWorkingDay';

export const getNextWorkingDays = (limit: number, holidaysList: string[], locale = 'it-IT'): string[] => {
  const today = new Date();
  const result = [];
  const MAX_ATTEMPTS = 12;

  for (let i = 1; i < MAX_ATTEMPTS; i++) {
    const date = new Date(today.toISOString().split('T')[0]);
    date.setDate(date.getDate() + i);
    if (isNextWorkingDay(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate(), holidaysList)) {
      const localizedDate = new Date(date).toLocaleDateString(locale);
      result.push(localizedDate);
    }
  }

  return result.slice(0, limit);
};
